var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 5000 5000",
    width: 5000,
    height: 5000,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_ZqXqKAXCzDeza316Zm0qLCdazMzSskXZ"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5000,
    height: 5000
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_ZqXqKAXCzDeza316Zm0qLCdazMzSskXZ)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5000,
    height: 5000,
    style: {
      fill: "rgb(0,0,0)"
    },
    fillOpacity: 0
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: " M 4224.385 893.024 C 4206.915 762.819 3714.472 677.684 3577.589 655.983 C 1999.268 401.415 1248.026 1418.701 1248.026 2405.256 C 1248.026 3380.925 2037.604 4149.825 3015.813 4149.825 C 3242.837 4149.825 3974.129 4050.853 4224.385 3378.457 C 4018.644 3590.041 3722.086 3608.821 3610.083 3608.821 C 2931.998 3608.821 2431.558 3083.341 2431.558 2405.256 C 2431.558 1727.172 2838.867 1278.48 3610.083 1080.592 C 4080.408 968.408 4231.954 1031.576 4224.385 893.024 Z ",
    fill: "rgb(255,255,255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 2561.143 1796.472 C 2620.706 1887.98 3049.868 2537.413 3500.958 2742.965 C 3220.591 3036.306 2742.11 2734.011 2447.631 2562.68 Q 2153.151 2391.35 2305.74 2053.544 Q 2449.603 1860.926 2561.143 1796.472 Z ",
    fill: "rgb(255,255,255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 3410.007 4203.108 C 3641.427 4122.763 3745.634 4091.708 3920.387 3958.362 C 4031.87 4071.361 4352.722 4391.6 4122.931 4880 C 3857.496 4326.378 3590.503 4268.329 3410.007 4203.108 Z ",
    fill: "rgb(255,255,255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 3569.377 547.367 Q 3019.599 63.504 2276.66 286.179 C 1844.312 404.851 1555.94 753.582 1338.514 1194.277 Q 603.971 1393.654 328.589 2129.084 C 795.496 1799.906 1033.784 1912.373 1182 2005.175 C 1337.404 1149.633 2135.692 316.993 3569.377 547.367 Z ",
    fill: "rgb(255,255,255)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.863c3d46934e85d11d6b55078d624464.svg";
export { ForwardRef as ReactComponent };